import ItemEmbedContainer from './ItemEmbedContainer';
export default ItemEmbedContainer;
